export const eventInquiryContact = {
  email: "blueagavedriggs@gmail.com",
  phone: "+1 (307) 690-7300",
  phoneHref: "tel:+13076907300",
  smsHref: "sms:+13076907300",
  whatsappNumber: "13076907300",
  endpoint: "https://formsubmit.co/ajax/blueagavedriggs@gmail.com",
};

export const eventTypeOptions: [english: string, spanish: string][] = [
  ["Private Event", "Evento privado"],
  ["Catering", "Catering"],
  ["Wedding", "Boda"],
  ["Wedding Reception", "Recepción de boda"],
  ["Birthday Celebration", "Cumpleaños"],
  ["Corporate Event", "Evento corporativo"],
  ["Family Gathering", "Reunión familiar"],
  ["Other Special Occasion", "Otra ocasión especial"],
];
